module.exports = __webpack_public_path__ + "static/PAAB_logo_color_FR-581fbb7c767aaa5e2e8bf93ab8def90b.png";